

<template>
  <div class="challenge-container">
    <div class="outbox technicalarticles" v-if="!complete">
      <div class="challenge-header">
        <div class="title">{{ challengeData.tasp_title }}</div>
        <div class="introduction" v-html="challengeData.tasp_content"></div>
      </div>
    
      <!-- 表单 -->
      <el-form 
        ref="form" 
        :model="formData" 
        :rules="rules" 
        label-position="top"
        class="apply-form">

        <el-form-item 
          :label="$t('行业类型')" 
          prop="tp_hy_dd_id">
          <el-select size="small" v-model="formData.tp_hy_dd_id" :placeholder="$t('请选择行业类型')">
            <el-option
              v-for="item in commonData.post_ins_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item 
          :label="$t('场景分类')" 
          prop="tp_cj_dd_id">
          <el-select size="small" v-model="formData.tp_cj_dd_id" :placeholder="$t('请选择场景分类')">
            <el-option
              v-for="item in commonData.post_scene_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item 
          :label="$t('文章标题')" 
          prop="tp_title">
          <el-input 
            maxlength="100"
            v-model="formData.tp_title" 
            :placeholder="$t('请填写文章标题')">
          </el-input>
        </el-form-item>
        <el-form-item
            :label="$t('文章来源')"
            prop="tp_cj_dd_id">
          <el-select size="small" v-model="formData.tp_source" :placeholder="$t('请选择来源')">
            <el-option
                v-for="item in commonData.post_source_list"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item 
          :label="$t('撰写文章')" 
          prop="tp_content">
          <!-- 富文本编辑器   -->
          <editor v-model="formData.tp_content" :height="500" :isUseOss="true"></editor>
        </el-form-item>

      </el-form>
      
      <div class="action-bar">
        <el-button type="text" class="submit-btn" v-throttle="2000" @click="submitForm">{{ $t('发布') }}</el-button>
      </div>
    </div>
    
    <Result v-if="complete" :typeNum="6" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" :continueAction="continueAction"></Result>

  </div>
</template>

<script>
import Editor from "../../components/Editor/index.vue";
import Result from './components/result.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';
import { getcommonData } from "@api/home";

export default {
  name: 'technicalarticles',
  components: {
    Result,
    Editor
  },
  data() {
    return {
      complete: false,
      challengeData: {
        title: '',
        introduction: '',
      },
      commonData: [],
      formData: {
        tp_title: '',
        tp_content: '',
        tp_source: 10,
        tp_hy_dd_id: '',
        tp_cj_dd_id : ''
      },
      rules: {
        tp_title: [
          { required: true, message: this.$t('请填写文章标题'), trigger: 'blur', validator: (rule, value, callback) => {
              if(/^[\s]*$/.test(value)){
                callback(new Error(this.$t('请填写文章标题')));
              }else{
                callback();
              }
            }
          }
        ],
        tp_hy_dd_id: [
          { required: true, message: this.$t('请选择行业类型'), trigger: 'blur' }
        ],
        tp_cj_dd_id : [
          { required: true, message: this.$t('请选择场景分类'), trigger: 'blur' }
        ],
        tp_content: [
          { required: true, message: this.$t('请填写文章内容'), trigger: 'blur', validator: (rule, value, callback) => {
              if(/^[\s]*$/.test(value)){
                callback(new Error(this.$t('请填写文章内容')));
              }else{
                callback();
              }
            }
         }
        ],
      }
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
	mounted(){
    this.getData();
	},
  methods: {
    async getData(){
      const res = await taskDetailList({ 
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //24
       });
      if(res.status == 200){
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          return;
        }
        this.challengeData = res.data.paper;
      }
      const res2 = await getcommonData();
      if(res2.status == 200){
        this.commonData = res2.data;
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 表单验证通过，可以提交数据
          let subObj = {
            ta_id: this.challengeData.ta_id,
            tas_id: this.challengeData.tas_id,
            tasp_id: this.challengeData.tasp_id,
            dd_question_type: this.challengeData.dd_question_type,
            data: this.formData
          }
          this.submitData(subObj);
        } else {
          // this.$message.error('请检查表单内容！');
          return false;
        }
      });
    },
    async submitData(subObj){
      const loading = this.$loading({
        lock: false,
        text: this.$t('加载中'),
        background: 'rgba(0, 0, 0, 0.1)'
      });
      const res = await taskSubmit(subObj);
      loading.close();
      if(res.status == 200){
          this.complete = true;
          this.formData = {
            tp_title: '',
            tp_content: '',
            tp_source: 10,
            tp_hy_dd_id: '',
            tp_cj_dd_id : ''
          };
          window.scrollTo({ top: 0, behavior: 'smooth' });
        this.$message.success(this.$t('发布成功'));
      }else{
        // this.$message.error(this.$t('提交失败'));
      }
    },
    continueAction(){
      this.complete = false;
      this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px 32px 0;
	&:last-child{
		margin-bottom: 0;
	}
}
.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  .technicalarticles{
    min-height: calc(100vh - 100px);
  }
  .challenge-header {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
			line-height: 30px;
      margin-bottom: 16px;
    }    
    .introduction {
      font-size: 14px;
      line-height: 24px;
			font-weight: 300;
      color: #595959;
    }
  }
  
  .section-title {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 14px;
  }


  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
    border-top: 1px dashed rgb(230, 230, 230);
    .submit-btn {
			box-sizing: border-box;
      font-size: 14px;
			border: 1px solid rgb(179, 0, 0);
			border-radius: 20px;
			width: 86px;
			background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
    }
  }
}

.apply-form {
  width: 100%;
  ::v-deep .tox.tox-tinymce.tox-fullscreen {
    background-color: transparent;
    box-sizing: border-box;
    padding-top: 60px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      padding: 0;
      line-height: 22px;
      margin-bottom: 8px;
      color: #191919;
    }
    
    .el-form-item__content {
      line-height: normal;
    }
    
    .el-input:not(.el-input--suffix) {
      width: 100%;
      
      .el-input__inner {
        width: 100%;
        height: 36px;
        line-height: 36px;
      }
    }
    .el-select{
      width: 75%;
      // .el-input__inner {
      //   width: 100%;
      //   height: 32px;
      //   line-height: 32px;
      // }
      // .el-input__suffix{
      //   top: 4px;
      // }
    }
    .el-textarea {
      width: 100%;
      
      .el-textarea__inner {
        width: 100%;
        line-height: 22px;
      }
      
      .el-input__count {
        right: 10px;
        bottom: 2px;
        font-size: 12px;
        color: #808080;
        background: transparent;
        line-height: 20px;
        height: 20px;
      }
    }
    .upload-demo{
      width: 100%;
      .el-upload-dragger{
        width: 100%;
        height: 150px;
        .el-icon-picture{
          font-size: 36px;
          color: #8abef3;
          margin: 32px 0 16px;
          line-height: 40px;
        }
      }
      .el-upload{
        width: 100%;
      }
      .el-upload__tip{
        color: #808080;
      }
      .el-upload__text{
        width: 100%;
        &.text2{
          color: #808080;
          font-size: 12px;
        }
        em{
          color: #0067D1;
        }
      }
    }
    .tox .tox-toolbar{
      background-color: #fff;
    }

  }
}
</style>